import { Checkbox } from '@ds';
import { InfoBanner } from '@ui';
import React from 'react';

interface ServiceWithoutCoordinatorCheckboxProps {
  isSelected: boolean;
  isDisabled: boolean;
  onValueChange: (val: boolean) => void;
  showInfoBanner: boolean;
}

export const ServiceWithoutCoordinatorCheckbox: React.FC<ServiceWithoutCoordinatorCheckboxProps> = ({
  isSelected,
  isDisabled,
  onValueChange,
  showInfoBanner,
}) => (
  <div className="flex flex-col justify-start items-start gap-3">
    <Checkbox
      size="md"
      isSelected={isSelected}
      isDisabled={isDisabled}
      onValueChange={onValueChange}
      className="select-none text-base-10"
    >
      Service without TX Center Coordinator
    </Checkbox>
    {showInfoBanner && (
      <InfoBanner iconType="warning">
        Selection of Service without TX Center Coordinator option will detach all the TX Center Coordinators from the
        case.
      </InfoBanner>
    )}
  </div>
);
